export default "/fonts/RV-Harmonia-SemiBold.svg?0e1254f5f7e9daf76438dbc9423aa4ea";